import { merge as _merge } from 'lodash'
import zh from 'core/translations/zh'

export default _merge(zh, {})
